import Select2FloatingLabel from './Select2FloatingLabel';
export default Select2FloatingLabel;
